export default "__VITE_ASSET__dde93f57__"